<template>
    <modal
        name="new-password"
        @before-open="beforeOpen"
        :classes="['v--modal', 'new-password']"
        :width="730"
        :height="'auto'"
        :adaptive="true"
    >
        <div class="modal-title">
            {{ $t("restoringAccess.restoringAccess") }}
        </div>
        <div class="modal-close" @click="close"></div>
        <div class="modal-body">
            <div class="form-group">
                <label for="register-password" class="label"
                    >{{ $t("register.password") }}:</label
                >
                <input
                    type="password"
                    v-model="password"
                    name="password"
                    id="register-password"
                    ref="password"
                    v-validate="'required|min:6'"
                    autocomplete="new-password"
                    class="input"
                    :class="{ 'field-error': errors.has('password') }"
                />
                <label for="register-password" class="v-error label-tip">{{
                    errors.first("password")
                }}</label>
            </div>
            <div class="form-group">
                <label for="password-confirm" class="label"
                    >{{ $t("newPassword.repeatPassword") }}:</label
                >
                <input
                    v-model="passwordConfirm"
                    type="password"
                    name="password-confirm"
                    id="password-confirm"
                    v-validate="'required|confirmed:password|min:6'"
                    autocomplete="new-password"
                    class="input"
                    :class="{ 'field-error': errors.has('password-confirm') }"
                />
                <label for="password" class="v-error label-tip">{{
                    errors.first("password-confirm")
                }}</label>
            </div>
            <div class="form-bottom buttons-center">
                <button
                    @click="resetPassword"
                    class="button"
                    :class="{ 'button-loader': loader }"
                >
                    {{ $t("threads.save") }}
                </button>
            </div>
        </div>
    </modal>
</template>

<script>
// import {checkScroll} from '@/mixins/checkScroll';
import { mapGetters } from "vuex";
import { localizeValidation } from "@/mixins/localizeValidation";
import { initAfterLogin } from "@/mixins/initAfterLogin";
import Vue from "vue";

export default {
    name: "NewPassword",
    props: {
        i18n: Object,
    },
    mixins: [localizeValidation, initAfterLogin],
    data() {
        return {
            loader: false,
            password: "",
            passwordConfirm: "",
            uid: "",
            token: "",
        };
    },
    computed: {
        ...mapGetters({
            user: "user/fetchUser",
            userErrors: "user/fetchUserErrors",
            resetType: "user/fetchResetType",
            isEmpty: "user/isEmpty",
        }),
    },
    methods: {
        beforeOpen(event) {
            this.localizeValidation();
            this.uid = event.params.uid;
            this.token = event.params.token;
        },
        resetPassword() {
            this.$validator.validateAll().then((valid) => {
                if (valid) {
                    this.loader = true;
                    this.$store
                        .dispatch("user/resetPasswordConfirm", {
                            data: {
                                phone_or_uid: this.uid,
                                token: this.token,
                                password: this.password,
                            },
                        })
                        .then(() => {
                            this.loader = false;
                            this.initAfterLogin();
                            this.password = "";
                            this.passwordConfirm = "";
                            this.errors.clear();
                            this.$validator.reset();
                            this.close();
                            if (
                                !this.isEmpty("user") &&
                                (!this.user.first_name ||
                                    !this.user.last_name ||
                                    (this.user.gender != 1 &&
                                        this.user.gender != 2) ||
                                    !this.user.birthday)
                            ) {
                                this.$modal.show("first-login");
                            }
                            const vm = new Vue();
                            vm.$connect();
                        })
                        .catch(() => {
                            this.loader = false;
                            for (let key in this.userErrors) {
                                this.errors.add({
                                    field: key,
                                    msg: this.userErrors[key][0],
                                });

                                if (key == "uid" || key == "token") {
                                    this.$modal.show("dialog", {
                                        title: this.$t(
                                            "restoringAccess.restoringAccess"
                                        ),
                                        text: this.$t(
                                            "restoringAccess.anErrorHasOccurred"
                                        ),
                                        buttons: [
                                            {
                                                title: this.$t(
                                                    "threads.mistake"
                                                ),
                                            },
                                        ],
                                    });
                                }
                            }
                        });
                }
            });
        },
        close() {
            this.$modal.hide("new-password");
        },
    },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/components/_validation";
</style>

<style lang="scss">
@import "~@/assets/styles/layout/_reset-password";
</style>
